__turbopack_context__.v({
  "header": "sheets-module__YHfSgq__header",
  "message": "sheets-module__YHfSgq__message",
  "muted": "sheets-module__YHfSgq__muted",
  "page": "sheets-module__YHfSgq__page",
  "sheetCaption": "sheets-module__YHfSgq__sheetCaption",
  "sheetCard": "sheets-module__YHfSgq__sheetCard",
  "sheetLink": "sheets-module__YHfSgq__sheetLink",
  "sheetList": "sheets-module__YHfSgq__sheetList",
  "sheetName": "sheets-module__YHfSgq__sheetName",
  "sheetToolbar": "sheets-module__YHfSgq__sheetToolbar",
});
